<template>
  <modal :show.sync=show modalClasses="medium-sized-modal" :hide-footer="true">
      <h3 slot="header" class="mb-0 font-weight-500">Create New Email Template</h3>

      <ValidationObserver v-slot="{ invalid }" ref="observer">
          <b-form @submit.prevent="submit" ref="emailTemplatesForm">
               <!-- Form fields -->
        <div>

          <b-row>
            <b-col lg="12">
              <base-input
                type="text"
                label="Template Name"
                placeholder="Template Name"
                v-model="form.notif_temp_title"
              ></base-input>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="12">
              <b-form-textarea
                label="Message"
                placeholder="Enter your message here..."
                v-model="form.notif_temp_message"
                rows="5"
                max-rows="10"
              ></b-form-textarea>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="12">
              <b-form-group label="Assign to Advisor">
                <b-form-select
                  v-model="form.notif_assign_advisor"
                  :options="assignAdvisorOptions"
                ></b-form-select>
              </b-form-group>
            </b-col>
          </b-row>
          <!-- Toggle for Assigned Advisor -->
          <!-- <b-row>
            <b-col lg="12">
              <b-form-group label="Send to Assigned Advisor Only">
                <b-form-checkbox v-model="form.notif_assign_advisor" switch class="ml-5">
                </b-form-checkbox>
              </b-form-group>
            </b-col>
          </b-row> -->
          <b-row>
            <b-col lg="12">
              <b-form-group label="Email Receiver">
                <!-- <b-form-select
                  v-model="form.notif_temp_receiver"
                  :options="userEmailOptions"
                  multiple
                ></b-form-select> -->
                <el-select v-model="form.notif_temp_receiver" placeholder="Receiver" filterable multiple>
                  <el-option
                    v-for="item in userEmailOptions"
                    :key="item.value"
                    :label="item.text"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="12">
              <b-form-group label="Trigger Point">
                <b-form-select
                  v-model="form.triggerPoint"
                  :options="emailTriggerPointOptions"
                ></b-form-select>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="12">
              <b-form-group label="Active or Not Active">
                <b-form-checkbox
                  v-model="form.toggle"
                  switch
                  class="ml-5"
                ></b-form-checkbox>
              </b-form-group>
            </b-col>
          </b-row>
        </div>

        <hr class="my-4" />
        <div class="text-right">
          <base-button type="primary" v-if="form.notif_temp_id === null" @click="addEmail">Save</base-button>
        </div>
          </b-form>
      </ValidationObserver>
  </modal>
</template>
<script>
import Modal from "@/components/Modal"
import { Select, Option, Checkbox } from 'element-ui'
import { 
  notifyFunctionMixin,
helperFunctionMixin,
axios,
services,
getHeader
} from '@/assets/js/httpImports.js'
import mainEventBus from '@/assets/js/mainEventBus'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import '@/assets/js/formValidations.js'
import { mapState , mapActions} from "pinia";
import { useAccessControlStore } from "@/stores/accessControlStore";
import { EMAIL_TRIGGER_POINTS , NOTIFICATION_TRIGGER_POINTS } from "@/assets/js/status.js";
import { useNotificationStore } from '@/stores/notificationStore'

export default {
  props:{
    create_new_email_templates: Boolean
  },
  mixins:[
      notifyFunctionMixin,
      helperFunctionMixin
  ],
  components: {
      Modal,
      ValidationObserver,
      ValidationProvider,
      [Select.name]: Select,
      [Option.name]: Option,
      [Checkbox.name]: Checkbox,
  },
  async created() {
    const notificationStore = useNotificationStore();
    // await notificationStore.fetchExistingData();

  },
  computed: {
    ...mapState(useAccessControlStore, ["userList"]), 
    show: {
          get() {
              return this.create_new_email_templates;
          },
          set(newVal) {
              this.$emit('update:create_new_email_templates', newVal);
          },
      },
    userEmailOptions() {
      return this.userList.map(user => ({
        value: user.email,
        text: user.email,
      }));
    },
    notifReceiver: {
      get() {
        return this.setupForm.notif_temp_receiver.map(Number);
      },
      set(val) {
        this.setupForm.notif_temp_receiver = val.map(String);
      },
    },
    emailTriggerPointOptions() {
      return Object.keys(EMAIL_TRIGGER_POINTS).map(key => ({
        value: key,
        text: EMAIL_TRIGGER_POINTS[key],
      }));
    },
    notificationTriggerPointOptions() {
      return Object.keys(NOTIFICATION_TRIGGER_POINTS).map(key => ({
        value: key,
        text: NOTIFICATION_TRIGGER_POINTS[key],
      }));
    },
    assignAdvisorOptions() {
      return [
        { value: 1, text: "Yes" },
        { value: 0, text: "No" }
      ];
    }
  },
  data() {
      return {
        form: {
        notif_temp_id: null, // Store the id of the existing template
        notif_temp_title: "",
        notif_temp_message: "",
        notif_temp_receiver: [],
        notif_assign_advisor: 0, // Default to No (0)
        triggerPoint: "", // Will be converted to trigger_point before sending
        toggle: true, // Default value for the toggle
      },
      }
  },
  methods: {
    ...mapActions(useNotificationStore, ['fetchExistingData','saveEmail','updateEmail','saveNotification','updateNotification']),

    async addEmail() {
    try {
      const payload = {
          ...this.form,
          notif_temp_type: 'email',
          is_active: this.form.toggle ? '1' : '0',
          notif_temp_receiver: this.form.notif_temp_receiver.join(','),
          trigger_point: this.form.triggerPoint,
          notif_assign_advisor: this.form.notif_assign_advisor ? 1 : 0, // Assign 1 for yes, 0 for no
        };

        await this.saveEmail(payload);
        this.notifySuccess("Data saved successfully.");
        this.$emit('closeEmailModal', false)
        mainEventBus.$emit('refresh-status')
        this.resetFormToNull(this.form)
        this.form.notif_temp_receiver = [];


    } catch (e) {
        console.log('Failed to save email:', error);
    }
  },
   }
}
</script>